// NOTE: NSAI-8170 — the deployed build's id, written next to index.html by
// vite-plugins/app-build-id.ts.
export const APP_VERSION_URL = "/version.json";

export const APP_VERSION_QUERY_KEY = "app-version";

// NOTE: How often a visible tab asks whether a newer build is deployed. Coming
// back to the tab asks at once, so this only bounds a tab left in front of the
// user; React Query pauses the interval while the tab is hidden.
export const APP_VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

// NOTE: One fixed id, so a repeated check updates the toast already on screen
// instead of stacking a second one.
export const APP_UPDATE_TOAST_ID = "app-update-available";

// NOTE: sessionStorage, not localStorage: closing the toast means "not now"
// for this tab, and a fresh tab already loads the newest build.
export const DISMISSED_APP_BUILD_ID_STORAGE_KEY = "dismissed_app_build_id";

// NOTE: Fired by Vite's preload helper when a lazy chunk fails to load — after
// a deploy the old build's chunks are no longer served, but a network blip
// fires it too.
export const VITE_PRELOAD_ERROR_EVENT = "vite:preloadError";
